import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { useI18n, CONTACT } from "@/lib/i18n";

const TILES = [
  "https://images.unsplash.com/photo-1758448756167-88dc934c58e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzdW5zZXQlMjB0ZXJyYWNlfGVufDB8fHx8MTc3ODQyNjc2MHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMGJlZHJvb20lMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzg0MjY3NTV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1757439401991-2c6c3df38349?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMHBvb2x8ZW58MHx8fHwxNzc4NDI2NzU1fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1773565744218-d8d11de58362?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzcGElMjBwcm9kdWN0cyUyMG9yZ2FuaWMlMjBsdXh1cnl8ZW58MHx8fHwxNzc4NDI2NzYwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1767950470198-c9cd97f8ed87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMHBvb2x8ZW58MHx8fHwxNzc4NDI2NzU1fDA&ixlib=rb-4.1.0&q=85",
];

export default function InstagramSection() {
  const { t } = useI18n();
  return (
    <section
      id="journal"
      className="bg-sand-50 py-24 md:py-32 lg:py-40"
      data-testid="instagram-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-12 md:mb-16">
          <div className="lg:col-span-7">
            <span className="block text-[10px] md:text-xs tracking-[0.4em] uppercase text-gold mb-6">
              — {t.instagram.kicker}
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif font-light leading-[1.05] tracking-tight text-4xl md:text-5xl lg:text-6xl text-ink-900"
              data-testid="instagram-title"
            >
              {t.instagram.title}
            </motion.h2>
          </div>
          <a
            href={CONTACT.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="lg:col-span-5 lg:justify-self-end group inline-flex items-center gap-3 text-ink-900 hover:text-gold-dark transition-colors"
            data-testid="instagram-cta"
          >
            <span className="text-[11px] tracking-[0.3em] uppercase">
              {t.instagram.handle}
            </span>
            <span className="flex items-center justify-center w-10 h-10 border border-ink-900 group-hover:bg-ink-900 group-hover:text-sand-50 transition-colors">
              <Instagram size={16} strokeWidth={1.2} />
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-2 md:gap-4">
          {TILES.map((src, i) => (
            <motion.a
              key={i}
              href={CONTACT.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative aspect-square overflow-hidden bg-ink-900"
              data-testid={`instagram-tile-${i}`}
            >
              <img
                src={src}
                alt={`Villa Reset Ibiza — editorial ${i + 1}`}
                className="w-full h-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-ink-900/0 group-hover:bg-ink-900/40 transition-colors duration-500" />
              <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <ArrowUpRight size={18} strokeWidth={1.2} className="text-sand-50" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
